import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { ProductServices } from "../../../../services";
import { ButtonCommon, DataTableProducts } from "../../../common";
import "./List-ProductsWithoutActivity.css";
import { FormattedMessage } from "react-intl";

const ListProductsWithoutActivity = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [products, setProducts] = useState([{}]);
  const [productSelection, setProductsSelection] = useState([]);

  const navigate = useNavigate();
  const params = useParams();

  // console.log('LIST PARAMS', params);

  async function getProductos() {
    try {
      setIsLoading(true);

      const getProductResponse =
        await ProductServices.GetProductsWithoutActivity();

      //   if (getProductResponse && getProductResponse.Status === 200) {
      //     setProducts(getProductResponse.Content);
      //   } else {
      //     setProducts([]);
      //   }

      if (getProductResponse && getProductResponse.Status === 200) {
        setProducts(getProductResponse.Content);

        if (props.onListProductChange)
          props.onListProductChange(getProductResponse.Content.length);
      } else {
        setProducts([]);

        if (props.onListProductChange) props.onListProductChange(0);
      }

      setIsLoading(false);
    } catch (error) {
      console.log(error);

      setIsLoading(false);
    }
  }

  useEffect(() => {
    getProductos();

    // if (props.onListProductChange) props.onListProductChange(products.length);
  }, []);

  const onSuscribeProductsSelectionChange = (value: any) => {
    setProductsSelection(value);
  };

  const onSuscribeDelete = (data: any) => {
    console.log("Click Borrar", data);
  };

  const onSuscribeDeleteGroup = (data: any) => {
    console.log("Click Borrar List", data);
  };

  const onSuscribeDownloadData = (data: any) => {
    console.log("Click Download", data);
  };

  const onClickGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <Row className="justify-content-center">
        <DataTableProducts
          products={products}
          isLoading={isLoading}
          scrollHeight={"flex"}
          handlerSelectionRow={onSuscribeProductsSelectionChange}
          //handlerDelete={onSuscribeDelete}
          //handlerDeleteGroup={onSuscribeDeleteGroup}
          handlerDownload={onSuscribeDownloadData}
        />
      </Row>
      <Row className="mt-3">
        <Col xs={1} className="ps-0 list-pwa-back-button">
          <ButtonCommon
            label={
              <FormattedMessage
                id="ready-size-Volver"
                defaultMessage="Volver"
              />
            }
            isOutline={true}
            eventClick={() => onClickGoBack()}
          />
        </Col>
        {/* <Col xs={1} className={((productSelection.length === 0) ? 'd-none' : 'd-block') + ' ps-0'}>
                    <ButtonCommon label="Guardar"
                        isOutline={false} 
                        disabled={((productSelection.length === 0) ? true : false)}
                        eventClick={onClickGoBack} />
                </Col> */}
      </Row>
      <br />
    </>
  );
};

export default ListProductsWithoutActivity;
